import { useNavigate, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './index.css';

// 默认头像（未填写时显示）
const DEFAULT_AVATAR = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

const AppHeader = ({ loggedInUser, onLogout }) => {
  const navigate = useNavigate();
  // 存储用户头像和昵称（从About页面同步）
  const [userProfile, setUserProfile] = useState({
    avatar: DEFAULT_AVATAR,
    name: "用户"
  });

  // 监听本地存储变化，同步About页面的信息
  useEffect(() => {
    const syncProfile = () => {
      const savedProfile = localStorage.getItem('blogProfile');
      if (savedProfile) {
        const parsed = JSON.parse(savedProfile);
        setUserProfile({
          avatar: parsed.avatar || DEFAULT_AVATAR,
          name: parsed.nickname || "用户"
        });
      }
    };

    // 初始化时读取一次
    syncProfile();
    // 监听storage事件（About页面保存后触发）
    window.addEventListener('storage', syncProfile);
    // 组件卸载时移除监听
    return () => window.removeEventListener('storage', syncProfile);
  }, []);

  return (
    <header className="blog-header">
      <div className="header-container">
        {/* Logo - 点击跳转首页 */}
        <Link to="/" className="header-logo">我的博客</Link>

        {/* 导航栏 */}
        <nav className="header-nav">
          <Link to="/" className="nav-link">首页</Link>
          <Link to="/archive" className="nav-link">归档</Link>
          <Link to="/write" className="nav-link">写文章</Link>
          <Link to="/about" className="nav-link">关于</Link>
        </nav>

        {/* 登录后显示：头像 + 欢迎语 + 退出按钮 */}
        {loggedInUser && (
          <div className="user-area">
            {/* 头像 - 点击跳转About页面 */}
            <img
              src={userProfile.avatar}
              alt="用户头像"
              className="user-avatar"
              onClick={() => navigate('/about')}
            />
            {/* 欢迎语 + 昵称 */}
            <span className="welcome-text">欢迎, {userProfile.name}</span>
            {/* 退出按钮 */}
            <button className="logout-btn" onClick={onLogout}>
              退出
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default AppHeader;